import { TRANSLATIONS } from 'constants/translations';

export const getTranslation = (locale) => TRANSLATIONS[locale];
